import { addMinutes } from "date-fns";

/**
 * Adds 5 minutes to the minimum date picker time to catch edge cases where the user selects the minDateTime but it changes while picking (due to time passing).
 */
export function adjustMinimumDatePickerTime(minDate: Date) {
  return addMinutes(minDate, 5);
}
